import type { GlobalState } from '../types';

// Bileli: immutable update for the Bileli-session slice. why: mirrors updateAuth so session-state
// changes follow the fork's reducer pattern (new object, never mutate).
export function updateBileliAuth<T extends GlobalState>(
  global: T, update: Partial<T['bileliAuth']>,
): T {
  return {
    ...global,
    bileliAuth: {
      ...global.bileliAuth,
      ...update,
    },
  };
}
